export default "__VITE_ASSET__BDSmjzbw__"